import * as React from 'react';

function SvgOpportunityStage(props) {
  return (
    <svg width={14} height={14} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.433 12.833H2c-.1 0-.167-.066-.167-.166V1.333c0-.1.067-.166.167-.166h9c.1 0 .167.066.167.166v3.434c0 .266.233.5.5.5.266 0 .5-.234.5-.5V1.333C12.167.7 11.633.167 11 .167H2C1.367.167.833.7.833 1.333v11.334c0 .633.534 1.166 1.167 1.166h3.433c.267 0 .5-.233.5-.5 0-.266-.233-.5-.5-.5zM10 6.167C7.9 6.167 6.167 7.9 6.167 10S7.9 13.833 10 13.833 13.833 12.1 13.833 10 12.1 6.167 10 6.167zm0 6.666A2.831 2.831 0 017.167 10 2.831 2.831 0 0110 7.167 2.831 2.831 0 0112.833 10 2.831 2.831 0 0110 12.833zm1.533-2.633L10.5 9.733v-1.4c0-.266-.233-.5-.5-.5s-.5.234-.5.5v1.734c0 .2.133.366.3.466l1.333.6a.423.423 0 00.2.034c.2 0 .367-.1.467-.3.1-.267 0-.534-.267-.667zm-1.7-7.033H3.167v1h6.666v-1zM3.167 5.833v1h2.8v-1h-2.8z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgOpportunityStage;
